export class AppSettings {

  static isProduction() {
    return process.env.NODE_ENV === 'production';
  }

  static getEnvVar(key) {
    if (window[key]) {
      return window[key];
    } else if (process.env[key]) {
      return process.env[key]
    }
    console.error(`Invalid key provided for env var. Key: ${key}`)
  }

  static url() {
    return this.getEnvVar('VUE_APP_API_URL') || null;
  }

  static wsUrl() {
    return this.getEnvVar('VUE_APP_WS_URL') || null;
  }

  static portalUrl() {
    return this.getEnvVar('VUE_APP_PORTAL_URL') || null;
  }

  static getUrl(url) {
    return this.url() + url;
  }

  static getWsUrl(url = '') {
    return this.wsUrl() + url;
  }


  static getTurnstileSiteKey() {
    return this.getEnvVar('VUE_APP_TURNSTILE_SITE_KEY') || '';
  }

  static getRollbarAccessToken() {
    return this.getEnvVar('VUE_APP_ROLLBAR_ACCESS_TOKEN') || '';
  }

  static getSupportChatUrl() {
    return this.getEnvVar('VUE_APP_SUPPORT_CHAT_URL') || 'https://artisio-chatbot.vercel.app';
  }

  static getBaseUrl() {
    return this.getEnvVar('BASE_URL') || '';
  }
}
